import { RuleValidation } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { GlobalDiscountRuleState } from './types'

export function validateGlobalDiscountRule(rule: GlobalDiscountRuleState): RuleValidation {
	if (rule.discount === null || rule.discount <= 0 || rule.discount > 100) {
		return { isValid: false, errors: { discount: 'invalid' } }
	}
	if (rule.threshold === null || rule.threshold <= 0) {
		return { isValid: false, errors: { threshold: 'invalid' } }
	}
	return { isValid: true, errors: {} }
}
